import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core';

import { ColorBox, PaletteFooter, Navbar } from 'app/components/index';

import styles from "../PaletteStyles";


class SingleColorPalette extends Component {
  constructor(props){
    super(props);
    this._shades = this.gatherShades(this.props.palette, this.props.colorId);
    this.gatherShades = this.gatherShades.bind(this);
    this.state={
      format:"hex"
    };
    this.changeFormat = this.changeFormat.bind(this);
  }
 gatherShades(palette, colorToFilterBy){
    let shades = []
    let allColors = palette.colors;
    for(let key in allColors){
      shades = shades.concat(
        allColors[key].filter(color => color.id === colorToFilterBy)
      );
    }
    //return all shades of given color,
    return shades.slice(1);
  }
  changeFormat(val){
    this.setState( { format: val } );
  }
  render() {
    const { format } = this.state;
    const {paletteName, emoji,id} = this.props.palette;
    const { classes } = this.props;
    const colorBoxes = this._shades.map(color => {
      return(
      <ColorBox 
        key={color.name} 
        name={color.name} 
        background={color[format]}  
        showingFullPalette={false}/>
        );
    });
    return (
      <div className={classes.Palette}>
        <Navbar handleFormatChange={ this.changeFormat } showingAllColors={ false }/>
        <div className={ classes.Colors }>
           { colorBoxes }
            <div className={ classes.goBack }>
              <Link to={`/palette/${id}`}>GO BACK</Link>
            </div>
        </div>
        <PaletteFooter 
          paletteName={ paletteName }
          emoji={ emoji }  
        />
      </div>
    )
  }
}

export default withStyles(styles)(SingleColorPalette);